import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import StripeV3Service from 'ember-stripe-elements/services/stripev3';
import BillingService from 'cio/services/billing';

export default class AccountCanceledRedirectRoute extends Route {
  @service('stripev3') stripe!: StripeV3Service;
  @service billing!: BillingService;

  async beforeModel() {
    await this.billing.initialize({ refresh: true, paramPlanSlug: '', code: '', ignoreErrors: true });
    return this.stripe.load();
  }
  redirect() {
    this.router.replaceWith('authenticated.account_canceled');
  }
}
